module.exports = __webpack_public_path__ + "static/media/wash1.2c022698.jpg";